
import { TranslationSet } from '../../types';

export const galleryUpload: TranslationSet = {
  'gallery.upload': {
    en: 'Upload Photo',
    ja: '写真をアップロード',
    es: 'Subir foto',
    zh: '上传照片',
    fa: 'آپلود عکس'
  },
  'gallery.uploadNewPhoto': {
    en: 'Upload New Photo',
    ja: '新しい写真をアップロード',
    es: 'Subir nueva foto',
    zh: '上传新照片',
    fa: 'آپلود عکس جدید'
  },
  'gallery.photoTitle': {
    en: 'Photo Title',
    ja: '写真のタイトル',
    es: 'Título de la foto',
    zh: '照片标题',
    fa: 'عنوان عکس'
  },
  'gallery.enterPhotoTitle': {
    en: 'Enter a title for your photo',
    ja: '写真のタイトルを入力してください',
    es: 'Introduce un título para tu foto',
    zh: '为您的照片输入标题',
    fa: 'عنوانی برای عکس خود وارد کنید'
  },
  'gallery.choosePhoto': {
    en: 'Choose Photo',
    ja: '写真を選ぶ',
    es: 'Elegir foto',
    zh: '选择照片',
    fa: 'انتخاب عکس'
  },
  'gallery.selectImageFile': {
    en: 'Select Image File',
    ja: '画像ファイルを選択',
    es: 'Seleccionar archivo de imagen',
    zh: '选择图像文件',
    fa: 'انتخاب فایل تصویر'
  },
  'gallery.uploading': {
    en: 'Uploading...',
    ja: 'アップロード中...',
    es: 'Subiendo...',
    zh: '上传中...',
    fa: 'در حال آپلود...'
  },
  'gallery.photoUploadedSuccess': {
    en: 'Photo uploaded successfully!',
    ja: '写真が正常にアップロードされました！',
    es: '¡Foto subida con éxito!',
    zh: '照片上传成功！',
    fa: 'عکس با موفقیت آپلود شد!'
  },
  'gallery.photoUploadFailed': {
    en: 'Failed to upload photo',
    ja: '写真のアップロードに失敗しました',
    es: 'Error al subir la foto',
    zh: '照片上传失败',
    fa: 'آپلود عکس با خطا مواجه شد'
  },
  'gallery.uploadPhoto': {
    en: 'Upload Photo',
    ja: '写真をアップロード',
    es: 'Subir foto',
    zh: '上传照片',
    fa: 'آپلود عکس'
  },
  'gallery.addPhoto': {
    en: 'Add Photo',
    ja: '写真を追加',
    es: 'Añadir foto',
    zh: '添加照片',
    fa: 'افزودن عکس'
  },
  'gallery.pregnancyPhotoUpload': {
    en: 'Upload Pregnancy Photo',
    ja: '妊娠写真をアップロード',
    es: 'Subir foto de embarazo',
    zh: '上传孕期照片',
    fa: 'آپلود عکس دوران بارداری'
  }
};
